// Which web build this is: `<commit>-<yymmdd.HHMM>` from scripts/deploy.sh (XM_BUILD at `vite build`), or 'dev-...'.
// Feedback reports and page errors carry it, so triage knows which version a problem was seen on.
export const BUILD: string = typeof __XM_BUILD__ === 'string' && __XM_BUILD__ ? __XM_BUILD__ : 'dev';
